<template>
  <div class="main-container">
    <div class="search-box min">
      <div class="input-item">
        <span class="label">文件名称</span>
        <Input v-model="searchParams.fileName" placeholder="请输入文件名称" clearable @on-enter="searchAjax()" />
      </div>
      <div class="input-item">
        <span class="label">可见级别</span>
        <Select v-model="searchParams.visibleLevel" placeholder="请选择可见级别" clearable>
          <Option v-for="item in visibleLevelOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" @click="$refs.editModal.open()">新增文件</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading || !!deletingId" />
      <Table :columns="columns" :data="tableData">
        <template slot="fileType" slot-scope="{ row }">{{ getFileType(row).toUpperCase() || '-' }}</template>
        <template slot="visibleLevels" slot-scope="{ row }">
          <div class="visible-level-tags">
            <Tag v-for="level in getVisibleLevels(row)" :key="level" color="blue">{{ visibleLevelOptions.find(item => item.value === level).label }}</Tag>
            <span v-if="!getVisibleLevels(row).length">-</span>
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span v-if="canPreview(row)" class="table-btn" @click="preview(row)">预览</span>
          <span class="table-btn" @click="download(row)">下载</span>
          <span class="table-btn" @click="$refs.editModal.open(row)">编辑</span>
          <span class="table-btn red" @click="del(row)">删除</span>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 50, 100]"
        show-total
        show-sizer
        @on-change="getList"
        @on-page-size-change="pageSizeChange"
        style="text-align: center"
      />
    </div>
    <edit-modal ref="editModal" @success="getList()" />
    <pdf-view ref="pdfView" />
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import pdfView from '@/components/commons/pdfView';
import editModal from './components/editModal';
import visibleLevelHelp from './components/visibleLevelHelp';
import { visibleLevelOptions, getVisibleLevels, getFileType } from './index.config';

export default {
  name: 'IfaCommissionFile',
  mixins: [pageTool],
  components: { pdfView, editModal },
  data() {
    return {
      visibleLevelOptions,
      deletingId: '',
      searchParams: { fileName: '', visibleLevel: '' },
      columns: [
        { title: '文件名称', key: 'fileName', minWidth: 220, tooltip: true },
        { title: '文件类型', slot: 'fileType', width: 100, align: 'center' },
        {
          title: '可见级别',
          slot: 'visibleLevels',
          width: 120,
          align: 'center',
          className: 'visible-level-column',
          renderHeader: h => h('span', [h('span', '可见级别'), h(visibleLevelHelp)])
        },
        { title: '排序', key: 'sortNo', width: 80, align: 'center', ellipsis: true, tooltip: true },
        { title: '备注', key: 'remark', minWidth: 200, tooltip: true },
        { title: '创建时间', key: 'createTime', width: 160, align: 'center', ellipsis: true, tooltip: true },
        { title: '操作', slot: 'action', width: 220, align: 'center', fixed: 'right' }
      ]
    };
  },
  created() {
    this.initListParams('/buz/ifaCommissionFile/queryPage');
  },
  activated() {
    this.getList();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    getVisibleLevels,
    getFileType,
    setListParams(params) {
      this.$units.delNull(params);
    },
    canPreview(row) {
      return ['pdf', 'png', 'jpg', 'jpeg'].includes(getFileType(row));
    },
    preview(row) {
      if (!row.fileUrl) {
        this.$notice.error('文件地址不存在');
        return;
      }
      this.$refs.pdfView.open([{ path: row.fileUrl, fileName: row.fileName }]);
    },
    download(row) {
      if (!row.fileUrl) {
        this.$notice.error('文件地址不存在');
        return;
      }
      const type = getFileType(row);
      let name = row.fileName || '佣金政策文件';
      if (type && !name.toLowerCase().endsWith('.' + type)) name += '.' + type;
      this.$units.downloadFun({ url: '/upload/downloadByUrl', params: { url: row.fileUrl } }, name);
    },
    del(row) {
      if (this.deletingId) return;
      this.deletingId = row.id;
      return this.$notice
        .inquiry('确定删除该佣金政策文件吗？删除后企微端将不再展示。')
        .then(() => {
          return this.$http({
            url: '/buz/ifaCommissionFile/delete',
            type: 'POST',
            data: { id: row.id }
          }).then(() => {
            this.$notice.success('删除成功');
            const page = this.tableData.length === 1 && this.pageNum > 1 ? this.pageNum - 1 : this.pageNum;
            this.getList(page);
          });
        })
        .catch(() => {})
        .finally(() => {
          this.deletingId = '';
        });
    }
  }
};
</script>

<style scoped>
::v-deep .visible-level-column .ivu-table-cell {
  padding-left: 8px;
  padding-right: 8px;
}
.visible-level-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px 8px;
}
.visible-level-tags .ivu-tag {
  margin: 0;
  flex-shrink: 0;
  white-space: nowrap;
}
</style>
